import {BMODELS_EMPTY, useBmodelMutations} from "../../api/bmodelsapi";
import React, {useCallback} from "react";
import {useForm} from "../../utilities/formutilities";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, Row} from "react-bootstrap";
import {Section} from "../grouping/Section";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {FaCheck} from "react-icons/fa";
import {FormControlCustom} from "../controls/FormControls";
import {Bounce, toast} from "react-toastify";
import {ModelBPdf} from "../formpdf/ModelBPdf";
import {pdf, PDFViewer} from "@react-pdf/renderer";
import {ModelAPdf} from "../formpdf/ModelAPdf";
import {useFileMutations} from "../../api/fileapi";
import {useEmailMutations} from "../../api/emailapi";
import {minioBaseUrl} from "../../data/defaultConfig";

export function BmodelForm(props) {
    const {onItemEditingChanged, itemEditing, onOpenChanged} = props;
    const {createBmodel, editBmodel} = useBmodelMutations();
    const {uploadFile} = useFileMutations();
    const {createFormEmail} = useEmailMutations();
    const initialObjectInintializer = useCallback(() => {
        return itemEditing ? itemEditing : BMODELS_EMPTY
    }, [])
    const {onChange, tempObject} = useForm(initialObjectInintializer);
    const notify = (message, type) => {
        toast(<div>
            <Row className={"g-0"}>
                <Col xs={12} className={"mb-3"}>
                    {message}
                </Col>
            </Row>
        </div>, {
            position: "top-right",
            autoClose: 5000,
            type: type,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
        });
    }

    async function handleCreate(event) {
        event.preventDefault();
        const response = await createBmodel(tempObject);
        if (response) {
            notify('Model B is verzonden.', 'success');
            const blob = await pdf(ModelBPdf({modelBTempObject: tempObject})).toBlob();
            const pdfFile = new File([blob], `modelB-${new Date().toISOString().substring(0, 10)}${new Date().getMinutes()}${new Date().getMilliseconds()}.pdf`);
            const uploadFileResult = await uploadFile({file: pdfFile});
            if (uploadFileResult) {
                const newEmail = {
                    title: "VBFlw, Nieuw Model B formulier ingevuld",
                    emailto: '',
                    emailfrom: "administratie@vbflw.be",
                    description: `
                    <p>Automatisch bericht van de VBFlw website:</p>
                    <p>Er is een Model B formulier ingevuld.</p>
                    <a href="${minioBaseUrl + uploadFileResult.url}">Click hier voor de pdf te downloaden</a>
                    `,
                    attachment: uploadFileResult.id
                };
                const emailResult = await createFormEmail(newEmail);
                if (emailResult) window.location.reload();
            }
        }
        if (!response) notify('Fout bij het verzenden. Probeer het later nog eens.', 'error');
    }


    async function handleEdit(e) {
        const result = await editBmodel(tempObject);
        if (result) {
            onItemEditingChanged(undefined);
            onOpenChanged(false);
        }
    }


    const formComplete =
        tempObject.provincie &&
        tempObject.sector &&
        tempObject.club &&
        tempObject.stamnr &&
        tempObject.vzw &&
        (tempObject.vzw === 'ja' ? tempObject.ondernemingsNummer : true) &&
        tempObject.naamSchuttersLokaal &&
        tempObject.adres &&
        (tempObject.telefoon || tempObject.gsm) &&
        tempObject.naamVoornaamVoorzitter &&
        tempObject.straatNrVoorzitter &&
        tempObject.postnrVoorzitter &&
        tempObject.telgsmemailVoorzitter &&
        tempObject.naamVoornaamSecretaris &&
        tempObject.straatNrSecretaris &&
        tempObject.postnrSecretaris &&
        tempObject.telgsmemailSecretaris &&
        tempObject.naamVoornaamPenningsmeester &&
        tempObject.straatNrPenningsmeester &&
        tempObject.postnrPenningsmeester &&
        tempObject.telgsmemailPenningsmeester;
    return <Form>
        <Section>

            <Col xs={6}>
                <FormControlCustom title={'Provincie*'} value={tempObject.provincie} filled={tempObject.provincie}
                                   onChange={e => onChange(e, 'provincie')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Sector*'} value={tempObject.sector} filled={tempObject.sector}
                                   onChange={e => onChange(e, 'sector')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Club*'} filled={tempObject.club} value={tempObject.club}
                                   onChange={e => onChange(e, 'club')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Stamnr*'} filled={tempObject.stamnr} value={tempObject.stamnr}
                                   onChange={e => onChange(e, 'stamnr')}/>
            </Col>
            <Col xs={tempObject.vzw === 'ja' ? 4:6}>
                <FormControlCustom title={'Gesticht in'} value={tempObject.gestichtin}
                                   onChange={e => onChange(e, 'gestichtin')}/>
            </Col>
            <Col xs={tempObject.vzw === 'ja' ? 4:6} className={'p-1'}>
                <Section className={"justify-content-center"}>
                    <Col xs={12}>
                        <FormLabel htmlFor={'vzwjn'}>VZW j/n* <span>  <FaCheck
                            className={tempObject.vzw ? '' : 'visually-hidden'}
                            style={{position: "relative", color: 'green'}}/></span></FormLabel>
                    </Col>
                    <Col xs={'auto'}>
                        <LabelWithInput title={'ja'}> <FormCheck id={'vzwja'} defaultChecked={tempObject.vzw === 'ja'}
                                                                 name={'vzw'} value={'ja'} type={'radio'}
                                                                 onChange={e => onChange(e, 'vzw')}/></LabelWithInput>

                    </Col>
                    <Col xs={'auto'}>
                        <LabelWithInput title={'nee'}> <FormCheck id={'vzwnee'}
                                                                  defaultChecked={tempObject.vzw === 'nee'} name={'vzw'}
                                                                  value={'nee'} type={'radio'}
                                                                  onChange={e => onChange(e, 'vzw')}/></LabelWithInput>
                    </Col>

                </Section>

            </Col>
            <Col hidden={tempObject.vzw !== 'ja'}  xs={4}>
                <LabelWithInput>
                    <FormControlCustom title={'Ondernemingsnummer*'} filled={tempObject.ondernemingsNummer}
                                       value={tempObject.ondernemingsNummer}
                                       onChange={e => onChange(e, 'ondernemingsNummer')}/></LabelWithInput>
            </Col>
        </Section>
        <hr/>
        <Section>
            <Col xs={6}>

                <FormControlCustom title={'Naam schutterslokaal*'} value={tempObject.naamSchuttersLokaal}
                                   filled={tempObject.naamSchuttersLokaal}
                                   onChange={e => onChange(e, 'naamSchuttersLokaal')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Adres*'} value={tempObject.adres} filled={tempObject.adres}
                                   onChange={e => onChange(e, 'adres')}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'Telefoon*'} value={tempObject.telefoon} filled={tempObject.telefoon}
                                   onChange={e => onChange(e, 'telefoon')}/>
            </Col>
            <Col xs={4}>
                <FormControlCustom title={'Gsm*'} value={tempObject.gsm} filled={tempObject.gsm}
                                   onChange={e => onChange(e, 'gsm')}/>
            </Col>
            <Col xs={4}>
                <FormControlCustom title={'Fax'} value={tempObject.fax} onChange={e => onChange(e, 'fax')}/>
            </Col>
        </Section>
        <hr/>
        <Section>
            <Col xs={2}>
                Voorzitter
            </Col>
            <Col xs={10}>
                <Section>
                    <Col xs={12}>
                        <FormControlCustom title={'Naam, Voornaam*'} value={tempObject.naamVoornaamVoorzitter}
                                           filled={tempObject.naamVoornaamVoorzitter}
                                           onChange={e => onChange(e, 'naamVoornaamVoorzitter')}/>
                    </Col>
                    <Col xs={12}>

                        <FormControlCustom title={'Straat, nr*'} value={tempObject.straatNrVoorzitter}
                                           filled={tempObject.straatNrVoorzitter}
                                           onChange={e => onChange(e, 'straatNrVoorzitter')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Postnr, Gemeente*'} value={tempObject.postnrVoorzitter}
                                           filled={tempObject.postnrVoorzitter}
                                           onChange={e => onChange(e, 'postnrVoorzitter')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Tel/Gsm/Email*'} value={tempObject.telgsmemailVoorzitter}
                                           filled={tempObject.telgsmemailVoorzitter}
                                           onChange={e => onChange(e, 'telgsmemailVoorzitter')}/>
                    </Col>
                </Section>
            </Col>
        </Section>
        <hr/>
        <Section>
            <Col xs={2}>
                Secretaris
            </Col>
            <Col xs={10}>
                <Section>
                    <Col xs={12}>
                        <FormControlCustom title={'Naam, Voornaam*'} value={tempObject.naamVoornaamSecretaris}
                                           filled={tempObject.naamVoornaamSecretaris}
                                           onChange={e => onChange(e, 'naamVoornaamSecretaris')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Straat, nr*'} value={tempObject.straatNrSecretaris}
                                           filled={tempObject.straatNrSecretaris}
                                           onChange={e => onChange(e, 'straatNrSecretaris')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Postnr, Gemeente*'} value={tempObject.postnrSecretaris}
                                           filled={tempObject.postnrSecretaris}
                                           onChange={e => onChange(e, 'postnrSecretaris')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Tel/Gsm/Email*'} value={tempObject.telgsmemailSecretaris}
                                           filled={tempObject.telgsmemailSecretaris}
                                           onChange={e => onChange(e, 'telgsmemailSecretaris')}/>
                    </Col>
                </Section>
            </Col>
        </Section>
        <hr/>

        <Section>
            <Col xs={2}>
                Penningsmeester
            </Col>
            <Col xs={10}>
                <Section>
                    <Col xs={12}>
                        <FormControlCustom title={'Naam, Voornaam*'} value={tempObject.naamVoornaamPenningsmeester}
                                           filled={tempObject.naamVoornaamPenningsmeester}
                                           onChange={e => onChange(e, 'naamVoornaamPenningsmeester')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Straat, nr*'} value={tempObject.straatNrPenningsmeester}
                                           filled={tempObject.straatNrPenningsmeester}
                                           onChange={e => onChange(e, 'straatNrPenningsmeester')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Postnr, Gemeente*'} value={tempObject.postnrPenningsmeester}
                                           filled={tempObject.postnrPenningsmeester}
                                           onChange={e => onChange(e, 'postnrPenningsmeester')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Tel/Gsm/Email*'} value={tempObject.telgsmemailPenningsmeester}
                                           filled={tempObject.telgsmemailPenningsmeester}
                                           onChange={e => onChange(e, 'telgsmemailPenningsmeester')}/>
                    </Col>
                </Section>
            </Col>
        </Section>
        <hr/>
        <Section>
            <Col xs={2}>
                Raadsleden
            </Col>
            <Col xs={10}>
                <Section>
                    <Col xs={12}>
                        <FormLabel>Naam, Voornaam</FormLabel>
                        <FormControl value={tempObject.naamVoornaamCommisaris1}
                                     onChange={e => onChange(e, 'naamVoornaamCommisaris1')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Straat, nr</FormLabel>
                        <FormControl value={tempObject.straatNrCommisaris1}
                                     onChange={e => onChange(e, 'straatNrCommisaris1')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Postnr, Gemeente</FormLabel>
                        <FormControl value={tempObject.postnrCommisaris1}
                                     onChange={e => onChange(e, 'postnrCommisaris1')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Tel/Gsm/Email</FormLabel>
                        <FormControl value={tempObject.telgsmemailCommisaris1}
                                     onChange={e => onChange(e, 'telgsmemailCommisaris1')}/>
                    </Col>
                </Section>
                <hr/>
                <Section>
                    <Col xs={12}>
                        <FormLabel>Naam, Voornaam</FormLabel>
                        <FormControl value={tempObject.naamVoornaamCommisaris2}
                                     onChange={e => onChange(e, 'naamVoornaamCommisaris2')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Straat, nr</FormLabel>
                        <FormControl value={tempObject.straatNrCommisaris2}
                                     onChange={e => onChange(e, 'straatNrCommisaris2')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Postnr, Gemeente</FormLabel>
                        <FormControl value={tempObject.postnrCommisaris2}
                                     onChange={e => onChange(e, 'postnrCommisaris2')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Tel/Gsm/Email</FormLabel>
                        <FormControl value={tempObject.telgsmemailCommisaris2}
                                     onChange={e => onChange(e, 'telgsmemailCommisaris2')}/>
                    </Col>
                </Section>
                <hr/>
                <Section>
                    <Col xs={12}>
                        <FormLabel>Naam, Voornaam</FormLabel>
                        <FormControl value={tempObject.naamVoornaamCommisaris3}
                                     onChange={e => onChange(e, 'naamVoornaamCommisaris3')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Straat, nr</FormLabel>
                        <FormControl value={tempObject.straatNrCommisaris3}
                                     onChange={e => onChange(e, 'straatNrCommisaris3')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Postnr, Gemeente</FormLabel>
                        <FormControl value={tempObject.postnrCommisaris3}
                                     onChange={e => onChange(e, 'postnrCommisaris3')}/>
                    </Col>
                    <Col xs={12}>
                        <FormLabel>Tel/Gsm/Email</FormLabel>
                        <FormControl value={tempObject.telgsmemailCommisaris3}
                                     onChange={e => onChange(e, 'telgsmemailCommisaris3')}/>
                    </Col>

                </Section>
            </Col>
            {itemEditing ? <Col xs={6} className={'p-1'}>
                <Section>
                    <Col xs={12}>
                        <FormLabel htmlFor={'vzwjn'}>Verwerkt? </FormLabel>
                    </Col>
                    <Col xs={'auto'}>
                        <LabelWithInput title={'ja'}> <FormCheck id={'verwerktja'} defaultChecked={tempObject.verwerkt}
                                                                 name={'verwerkt'} value={"true"} type={'radio'}
                                                                 onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>

                    </Col>
                    <Col xs={'auto me-2'}>
                        <LabelWithInput title={'nee'}> <FormCheck id={'verwerktnee'}
                                                                  defaultChecked={!tempObject.verwerkt}
                                                                  name={'verwerkt'}
                                                                  value={"false"} type={'radio'}
                                                                  onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>
                    </Col>
                </Section>
            </Col> : ''}
            <Col xs={12} className={'text-end mt-2'}>
                <Button disabled={!formComplete}
                        onClick={e => itemEditing ? handleEdit(e) : handleCreate(e)}>{!formComplete ? 'Nog niet alle verplichte * velden zijn ingevuld!' : 'Submit'}</Button>
            </Col>
        </Section>
    </Form>
}